import { FunctionComponent, useState } from 'react';
import PaperLayout from '../layout/PaperLayout';
import { BookingsSortDirection, BookingsSortOrder } from './bookingConstants';
import { useActiveBookings } from './bookingService';
import BookingList from './components/BookingList';

const Bookings: FunctionComponent = () => {
    const [assetId, setAssetId] = useState<string | undefined>();
    const { bookings, isLoading, refetch } = useActiveBookings(assetId);

    return (
        <PaperLayout heading="Bokade resurser">
            <BookingList
                bookings={bookings}
                defaultSortDirection={BookingsSortDirection.Ascending}
                defaultSortOrder={BookingsSortOrder.Date}
                filterNoBookingsHeading="Hoppsan! Här var det tomt"
                filterNoBookingsText="Just nu finns inga aktiva bokningar för den valda resursen. När den bokats kommer det synas här."
                hasAssetFilter={!!assetId}
                isArchived={false}
                isLoading={isLoading}
                noBookingsHeading="Här visas bokade resurser"
                noBookingsText="Just nu finns inga aktiva bokningar. När en resurs har bokats kommer det synas här."
                onAssetFilterChange={setAssetId}
                refetch={refetch}
            />
        </PaperLayout>
    );
};

export default Bookings;
